export class ClickOnInit implements ng.IDirective {
    link: ($scope: ng.IScope, element: ng.IAugmentedJQuery,
           attrs: ng.IAttributes) => void = ($scope: ng.IScope, element: ng.IAugmentedJQuery,
                                             attrs: ng.IAttributes) => {
        console.log('ClickOnInit', 'link');
        if (element && element.length) {
            setTimeout(() => {
                console.log('ClickOnInit', 'click');
                element[0].click();
                console.log('ClickOnInit', 'clicked');
            }, 1);
        }
    };

    static factory(): ng.IDirectiveFactory {
        const directive = () => new ClickOnInit();
        directive.$inject = [];
        return directive;
    }
}
